import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import integrationsHero from "../assets/Hero/integrations.jpeg"; // Replace with your hero image
import integrationsImage from "../assets/Hero/system-Integration.png"; // Replace with your integrations image
import "../assets/css/integrationsPage.css";

// Register the ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

// JSON data for headings and paragraphs
const integrationsData = {
  hero: {
    title: "Integrations",
    subtitle: "Seamlessly Connect Your Systems and Applications",
  },
  introduction: {
    heading: "Why Integrations Matter",
    paragraphs: [
      "Integrations enable seamless communication between different systems and applications, improving efficiency and reducing manual effort.",
      "Our integration solutions are designed to provide robust connectivity, real-time data synchronization, and enhanced operational workflows.",
    ],
  },
  cta: {
    heading: "Ready to Streamline Your Systems?",
    text: "Contact us today to learn more about our Integration Solutions and how we can help your business thrive.",
  },
};

export const IntegrationsPage = ({ data }) => {
  const integrationsRef = useRef(null);
  const navigate = useNavigate(); // Initialize useNavigate

  useEffect(() => {
    const elements = integrationsRef.current.querySelectorAll(".integrations-animate");

    gsap.fromTo(
      elements,
      { y: 100, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 1.0,
        ease: "power3.out",
        stagger: 0.2,
        scrollTrigger: {
          trigger: integrationsRef.current,
          start: "top 80%",
          toggleActions: "play none none reset",
        },
      }
    );
  }, []);

  // Function to handle navigation
  const handleContactClick = () => {
    navigate("/contact"); // Navigate to the contact page
  };

  return (
    <div id="integrations-page" ref={integrationsRef}>
      {/* Hero Section */}
      <div
        className="integrations-hero-section"
        style={{ backgroundImage: `url(${integrationsHero})` }}
      >
        <h1 className="integrations-animate">{integrationsData.hero.title}</h1>
        <p className="integrations-animate">{integrationsData.hero.subtitle}</p>
      </div>

      {/* Introduction Section */}
      <div className="container integrations-introduction">
        <div className="row">
          <div className="col-md-6">
            <h2 className="integrations-animate">{integrationsData.introduction.heading}</h2>
            {integrationsData.introduction.paragraphs.map((paragraph, index) => (
              <p key={index} className="integrations-animate">
                {paragraph}
              </p>
            ))}
          </div>
          <div className="col-md-6 integrations-image-container">
            <img
              src={integrationsImage}
              className="img-fluid integrations-animate"
              alt="Integrations"
            />
          </div>
        </div>
      </div>

      {/* Call to Action Section */}
      {/* <div className="container integrations-cta">
        <h2 className="integrations-animate">{integrationsData.cta.heading}</h2>
        <p className="integrations-animate">{integrationsData.cta.text}</p>
        <button
          className="btn btn-primary integrations-animate"
          onClick={handleContactClick} // Add onClick handler
        >
          Contact Us
        </button>
      </div> */}
    </div>
  );
};